import CampaignIcon from '@mui/icons-material/CampaignRounded';
import styled from 'styled-components';

export const BrandVoiceIcon = styled(CampaignIcon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.componentsIconDefault};
`;
